import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1>Let's Invent</h1>
        </div>
    );
};

export default Inventory;